"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;
var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFaucet = void 0;
var core_1 = require("@usedapp/core");
var ethers_1 = require("ethers");
var lodash_1 = require("lodash");
var react_1 = require("react");
var useRefreshOrNever_1 = __importDefault(require("../../hooks/useRefreshOrNever"));
var useGasFees_1 = require("../base/hooks/useGasFees");
var react_2 = require("../base/react");
var constants_1 = require("../constants");
var throttledFetch = (0, lodash_1.throttle)(fetch, 60000, {
  leading: true
});
// default wait roughly 1 minute
var useFaucet = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var refresh,
      refreshOrNever,
      _ref2,
      notifications,
      latest,
      lastNotification,
      _ref3,
      account,
      chainId,
      balance,
      _ref4,
      baseEnv,
      faucet,
      _ref5,
      _ref5$gasPrice,
      gasPrice,
      minBalance,
      faucetResult,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          refresh = _args.length > 0 && _args[0] !== undefined ? _args[0] : 12;
          refreshOrNever = (0, useRefreshOrNever_1.default)(refresh);
          _ref2 = (0, core_1.useNotifications)(), notifications = _ref2.notifications;
          latest = (0, react_1.useMemo)(function () {
            return (0, lodash_1.maxBy)(notifications, "submittedAt");
          }, [notifications]);
          lastNotification = (0, react_1.useRef)((latest === null || latest === void 0 ? void 0 : latest.submittedAt) || 0);
          _ref3 = (0, core_1.useEthers)(), account = _ref3.account, chainId = _ref3.chainId; // if we connected wallet or did a tx then force a refresh
          if (latest && latest.type !== "transactionStarted" && (latest === null || latest === void 0 ? void 0 : latest.submittedAt) > lastNotification.current) {
            lastNotification.current = latest === null || latest === void 0 ? void 0 : latest.submittedAt;
            refreshOrNever = 1;
          }
          balance = (0, core_1.useEtherBalance)(account, {
            refresh: refreshOrNever
          }); // refresh roughly once in 1 minute
          _ref4 = (0, react_2.useGetEnvChainId)(), baseEnv = _ref4.baseEnv; // get the env the user is connected to
          faucet = (0, react_2.useGetContract)(chainId === constants_1.SupportedChains.FUSE ? "FuseFaucet" : "Faucet", true, "base");
          _ref5 = (0, useGasFees_1.useGasFees)(), _ref5$gasPrice = _ref5.gasPrice, gasPrice = _ref5$gasPrice === void 0 ? ethers_1.BigNumber.from(5e9) : _ref5$gasPrice;
          minBalance = ethers_1.BigNumber.from(chainId === 42220 ? "250000" : "150000").mul(gasPrice);
          faucetResult = (0, core_1.useCalls)([{
            contract: faucet,
            method: "canTop",
            args: [account]
          }, {
            contract: faucet,
            method: "getToppingAmount",
            args: []
          }].filter(function (_) {
            return account && _.contract;
          }), {
            refresh: refreshOrNever
          });
          (0, react_1.useEffect)(function () {
            var _a, _b;
            if (!account) {
              return;
            }
            var _ref6 = faucetResult.map(function (_) {
                var _a;
                return (_a = _ === null || _ === void 0 ? void 0 : _.value) === null || _a === void 0 ? void 0 : _a[0];
              }) || [],
              _ref7 = _slicedToArray(_ref6, 2),
              canTop = _ref7[0],
              toppingAmount = _ref7[1];
            var threshold = ((_a = toppingAmount === null || toppingAmount === void 0 ? void 0 : toppingAmount.mul(50)) === null || _a === void 0 ? void 0 : _a.div(100)) || minBalance;
            console.log("faucet:", {
              canTop: canTop,
              balance: balance,
              threshold: threshold,
              account: account,
              toppingAmount: toppingAmount
            });
            if (canTop && balance && balance.lte(threshold)) {
              var devEnv = baseEnv === "fuse" ? "development" : baseEnv;
              var backend = constants_1.Envs[devEnv].backend;
              (_b = throttledFetch(backend + "/verify/topWallet", {
                method: "POST",
                body: JSON.stringify({
                  chainId: chainId,
                  account: account
                }),
                headers: {
                  "content-type": "application/json"
                }
              })) === null || _b === void 0 ? void 0 : _b.catch(function (e) {
                console.error("topping wallet failed:", e.message, e);
              });
            }
          }, [faucetResult, account, balance, baseEnv, chainId, minBalance]);
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function useFaucet() {
    return _ref.apply(this, arguments);
  };
}();
exports.useFaucet = useFaucet;